import { ICompany } from 'types/company/company';
import { companiesAPIUrls } from './companiesApi';
import { List } from 'types/api';
import { useSWRResource } from 'util/resource/useSWRResource';
import { swrOptions } from 'apis/ApiBase';
import { postFetcher } from 'apis/utils';
import useSWR from 'swr';

export const companyBasicProfileKey = (companyId: number) => companiesAPIUrls.companyProfile.get(companyId.toString());
export const companyBasicProfilesKey = (companyIds: number[]) =>
  companiesAPIUrls.companyProfiles.list() + `?ids=${companyIds.sort().join(',')}`;

export const useCompanyProfiles = (companyIds: number[]) => {
  const swrResult = useSWR<List<ICompany>>([companiesAPIUrls.companyProfiles.list(), { companyIds }], postFetcher, {
    ...swrOptions,
    keepPreviousData: true, // This doesn't make that much sense, but the UX is slightly better.
  });
  return useSWRResource(swrResult);
};
